import importExport from './import&export.vue'
export default {
  components: { importExport },
  methods: {
    importProduct() {
      this.$router.push({
        path: '/import-task',
        query: {
          appCode: 'soft-vote-web',
          from: 'shop'
        }
      })
    },
    // 导出 --新接口
    onExport() {
      let params = {
        taskDTO: {
          appCode: "ec-pc-api",
          paramMap: this.formData,
          reportName: 'reviewProductExport',
        },
        columnDTOs: [],
      };
      let labels = this.columnData.map(v=>v.label);
      let props = this.columnData.map(v=>v.prop);
      props.forEach((prop, index) => {
        params.columnDTOs.push({
          columnName: labels[index],
          parentColumnName: null,
          fieldName: prop,
          fieldType: 'string',
          columnFormat: null
        })
      })
      // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      });
      // let params = {
      //   appCode: "ec-pc-api",
      //   paramMap: {
      //     ...this.formData
      //   },
      //   reportName: "reviewProductExport",
      // };
      // this.$q.common.exportExcel({data: params}).then((res) => {
      //   this.$message({
      //     type: "success",
      //     message: "导出成功,请在导出列表中查看",
      //   });
      // });
    },
  }
}